import {
  GET_BULK_LIST,
  GET_BULK_LIST_SUCCESS,
  GET_BULK_LIST_FAIL,
  SEND_BULK_SMS,
  SEND_QUICK_SMS,
  SEND_BULK_SMS_SUCCESS,
  SEND_QUICK_SMS_SUCCESS,
  UPDATE_SENT_SMS,
  GET_BULK_LIST_DELIVERY_SUCCESS,
  GET_BULK_SCHEDULE_SUCCESS,
  GET_BULK_SCHEDULE_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  bulkLists: [],
  bulkTotal: 0,
  bulkTotalPages: 0,
  bulkDeliveryList: [],
  bulkSchedule: {},
  quickSent: false,
  bulkSent: false,
  error: {},
  loading: true
}

const bulkLists = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_BULK_LIST_SUCCESS:
      // payload is { rows, total, totalPages } (or a bare array, back-compat).
      return {
        ...state,
        bulkLists: Array.isArray(action.payload) ? action.payload : action.payload.rows,
        bulkTotal: Array.isArray(action.payload)
          ? action.payload.length
          : action.payload.total ?? 0,
        bulkTotalPages: Array.isArray(action.payload) ? 1 : action.payload.totalPages ?? 0,
        loading: true
      }
    case GET_BULK_LIST_DELIVERY_SUCCESS:
      return {
        ...state,
        bulkDeliveryList: action.payload,
        loading: true
      }
    case GET_BULK_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case SEND_BULK_SMS_SUCCESS:
      return {
        ...state,
        bulkSent: true,
      }
    case SEND_QUICK_SMS_SUCCESS:
      return {
        ...state,
        quickSent: true,
      }
    case GET_BULK_SCHEDULE_SUCCESS:
      return {
        ...state,
        bulkSchedule: action.payload,
      }
      case GET_BULK_SCHEDULE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case UPDATE_SENT_SMS:
      return {
        ...state,
        quickSent: false,
        bulkSent: false,
      }

    // case ADD_USER_SUCCESS:

    //   return {
    //     ...state,
    //     users: [action.payload, ...state.users],
    //   }

    // case ADD_USER_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //   }

    // case GET_USER_PROFILE_SUCCESS:
    //   return {
    //     ...state,
    //     userProfile: action.payload,
    //   }

    // case UPDATE_USER_SUCCESS:
    //   return {
    //     ...state,
    //     users: state.users.map(user =>
    //       user.id.toString() === action.payload.id.toString()
    //         ? { user, ...action.payload }
    //         : user
    //     ),
    //   }

    // case UPDATE_USER_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //   }

    // case DELETE_USER_SUCCESS:
    //   return {
    //     ...state,
    //     users: state.users.filter(
    //       user => user.id.toString() !== action.payload.toString()
    //     ),
    //   }

    // case DELETE_USER_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //   }

    // case GET_USER_PROFILE_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //   }

    default:
      return state
  }
}

export default bulkLists
